import { ActiveRecord } from '../../models/record';

export class SetActiveRecord {
  static readonly type = '[User list] Set active record';

  constructor(public record?: ActiveRecord) {}
}

export class SetActiveTab {
  static readonly type = '[User list] Set active tab';

  constructor(public index: number) {}
}

export class ResetStore {
  static readonly type = '[User list] Reset store';
}
